import React from 'react';
import pluralize from 'pluralize';

import { Text } from '@nerdwallet/currency/components/Text';
import { Box } from '@nerdwallet/currency/components/Box';

import { AccountLinkingIcon } from '../../dashboard-icons/dashboard-icons';

import { usePlaidFooterInstitutionContext } from '@components/financial-institutions/plaid-sandbox/plaid-footer-institution-context';

import styles from './styles.module.scss';

const LinkingInstitutions: React.FC = () => {
  const { linkingState } = usePlaidFooterInstitutionContext();

  if (!linkingState.isLinking) {
    return null;
  }

  return (
    <div className={styles.container}>
      <AccountLinkingIcon />

      <Box marginLeft={3}>
        <Text bold size="small">
          Linking {pluralize('account', linkingState.numAccountsLinking, true)}
          ...
        </Text>
      </Box>
    </div>
  );
};

export default LinkingInstitutions;
